export default "__VITE_ASSET__D$ggsEhf__"